import { render, staticRenderFns } from "./Edit-User-To-Folder.vue?vue&type=template&id=346bb004&scoped=true&"
import script from "./Edit-User-To-Folder.vue?vue&type=script&lang=js&"
export * from "./Edit-User-To-Folder.vue?vue&type=script&lang=js&"
import style0 from "./Edit-User-To-Folder.vue?vue&type=style&index=0&id=346bb004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346bb004",
  null
  
)

export default component.exports